<template lang="pug">
v-dialog(v-model="dialog", width="828")
  v-card
    v-card-title Parallax
    v-card-text
      v-col(align="center")
        v-slider(
          v-model="height",
          min="200",
          max="600",
          step="5",
          label="Height",
          thumb-label="always",
          color="secondary",
          track-color="success"
        )
        croppa(
          v-model="myCroppa",
          :width="800",
          :height="height",
          :quality="2",
          :canvas-color="canvas_color",
          initial-size="contain"
        )
    v-card-actions
      v-btn(@click="upload", color="secondary", :loading="loading") Upload
</template>

<script>
export default {
  props: ["chain"],
  data() {
    return {
      myCroppa: {},
      height: 400,
      dialog: false,
      loading: false,
      canvas_color: "#FFFFFF", // background color
    };
  },
  methods: {
    open() {
      // this.myCroppa?.remove();
      this.dialog = true;
    },
    upload() {
      this.myCroppa.generateBlob(
        (blob) => {
          if (!blob) {
            this.myCroppa.chooseFile();
          } else {
            this.save(blob);
          }
        },
        "image/jpeg",
        0.8
      );
    },
    async save(blob) {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("file", blob);
        formData.append("id", this.chain._id);
        const result = await this.$api.chain.account.custom(
          "updateParallax",
          formData
        );
        this.$emit("updated", result);
        this.$toast.success("Parallax updated");
        this.myCroppa?.remove();
        this.dialog = false;
      } catch (e) {
        this.$toast.error(e.response?.data || "Failed to update Parallax");
      }
      this.loading = false;
    },
  },
};
</script>